import { Text } from "@utils/helper";
import { useActivePath } from "Hooks/useActivePath";
import Link from "next/link";

const SidebarLink = ({ link, dispatch }) => {
  const isActive = useActivePath(link.to);

  return (
    <Link
      href={link.to}
      key={link.title}
      className="w-full flex items-center gap-2 relative focus:outline-none"
      onClick={() => dispatch({ openDrawer: false })}
    >
      {/* Active Link Indicator */}
      {isActive && (
        <div className="absolute left-[-5px] w-[5px] h-8 bg-[#FFFFFF] ltr:left-0 rtl:right-0 ltr:rounded-r-[50px] rtl:rounded-l-[50px]" />
      )}
      <div className="flex items-center gap-4 ltr:pl-[52px] rtl:pr-[52px]">
        {isActive ? link.activeIcon : link.icon}
        <Text
          color="white"
          className={`${isActive ? "font-bold" : "font-normal"}`}
        >
          {link.title}
        </Text>
      </div>
    </Link>
  );
};

export default SidebarLink;
